module.exports = __webpack_public_path__ + "166bd8a3dafdcaafc57432d9eeafdc23.svg";